import { Component, Input } from '@angular/core';


import { ShBaseCell } from '../_base/base-cell.component';
import { CheckboxCell } from './checkbox-cell.entity';

@Component({
    standalone: true,
    selector: 'sh-checkbox-cell',
    templateUrl: './checkbox-cell.component.html',
    imports: []
})
export class ShCheckboxCellComponent extends ShBaseCell {
    @Input() public cell!: CheckboxCell;

    onChange(): void {
        this.cell.onToggleAction(this.cell.rowId);
    }
}
